export const WIDGET_REPORTS = {
  GENERAL_REPORT: 'generalReport',
  COHORT_ANALYSIS: 'cohortAnalysis',
  COHORT_ANALYSIS_CUMULATIVE: 'cohortAnalysisCumulative',
  BUDGET_PLAN: 'budgetPlan',
  BUDGET_PLANNER: 'budgetPlanner',
  DASHBOARD_REPORT: 'dashboardReport',
  PAYMENT_INVOICE: 'paymentInvoice',
}